import { render, staticRenderFns } from "./AboutWeb.vue?vue&type=template&id=da7998bc"
import script from "./AboutWeb.vue?vue&type=script&lang=js"
export * from "./AboutWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports